import { v4 as uuid } from "uuid";

export const homeBanners = [
  {
    _id: uuid(),
    imageUrl: "/assets/Home/banners/banner-1.svg",
    title: "Lorem ipsum dolor sit amet",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Atque, ratione ipsum dicta molestiae voluptates quaerat eius saepe vel nisi repellat!",
  },
  {
    _id: uuid(),
    imageUrl: "/assets/Home/banners/banner-2.svg",
    title: "Lorem ipsum dolor sit amet",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Atque, ratione ipsum dicta molestiae voluptates quaerat eius saepe vel nisi repellat!",
  },
  {
    _id: uuid(),
    imageUrl: "/assets/Home/banners/banner-3.svg",
    title: "Lorem ipsum dolor sit amet",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Atque, ratione ipsum dicta molestiae voluptates quaerat eius saepe vel nisi repellat!",
  },
  {
    _id: uuid(),
    imageUrl: "/assets/Home/banners/banner-4.svg",
    title: "Lorem ipsum dolor sit amet",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Atque, ratione ipsum dicta molestiae voluptates quaerat eius saepe vel nisi repellat!",
  },
  {
    _id: uuid(),
    imageUrl: "/assets/Home/banners/banner-5.svg",
    title: "Lorem ipsum dolor sit amet",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Atque, ratione ipsum dicta molestiae voluptates quaerat eius saepe vel nisi repellat!",
  },
  {
    _id: uuid(),
    imageUrl: "/assets/Home/banners/banner-6.svg",
    title: "Lorem ipsum dolor sit amet",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Atque, ratione ipsum dicta molestiae voluptates quaerat eius saepe vel nisi repellat!",
  },
];
